export function extractTimeRange(input) {
  const regex = /(\d{2}:\d{2}\s*-\s*\d{2}:\d{2})/;
  const match = input.match(regex);

  if (match) {
    return match[0];
  } else {
    return null;
  }
}
